import COLOR from 'constants/color';
import { IconProps } from 'interfaces';
import { isDarkMode } from 'utils/validators';

const DownloadApps = ({
  className = '~w-4/5 ~h-4/5',
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.WHITE
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <rect
        x='6'
        y='2.5'
        width='12'
        height='19'
        rx='2.25'
        stroke={fillColor}
        strokeWidth='1.75'
      />
      <path
        d='M12 7.25v6.5'
        stroke={fillColor}
        strokeWidth='1.75'
        strokeLinecap='round'
      />
      <path
        d='M9.25 11.5L12 14.25L14.75 11.5'
        stroke={fillColor}
        strokeWidth='1.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 18.25h4'
        stroke={fillColor}
        strokeWidth='1.75'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default DownloadApps;
